import { render } from "./paymentlayerModel.vue?vue&type=template&id=0030438c"
import script from "./paymentlayerModel.vue?vue&type=script&lang=js"
export * from "./paymentlayerModel.vue?vue&type=script&lang=js"

import "./paymentlayerModel.vue?vue&type=style&index=0&id=0030438c&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__